import gql from 'graphql-tag';

export const PROGRAM_ONBOARDING_TEMPLATE_FRAGMENT = gql`
  fragment ProgramOnboardingTemplateFragment on ProgramOnboardingTemplate {
    id
    applicationTitle
    brandName
    brandLogo
    startDate
    endDate
    socialMediaHandles {
      handle
      type
    }
    pageUrl
    isPublished
    programId
    createdDate
    updatedDate
    templateType
    config {
      hero {
        title
        description
        carouselImages
        ctaButtonText
        listItems {
          text
          icon
        }
        listStyleType
        isVisible
        order
      }
      about {
        title
        description
        images
        isVisible
        order
      }
      perks {
        title
        description
        listItems {
          text
          icon
        }
        listStyleType
        isVisible
        order
      }
      persona {
        title
        description
        images
        listItems {
          text
          icon
        }
        listStyleType
        isVisible
        order
      }
      forms {
        title
        description
        applicationFormFields {
          memberFieldSchemas {
            schemaId
            required
            label
            order
          }
          dbColumns {
            name
            required
            label
            order
          }
        }
        isVisible
        order
      }
      brief {
        title
        description
        ctaButtonText
        order
      }
      products {
        title
        description
        ctaButtonText
        order
      }
      confirmation {
        primaryMessage
        description
        order
      }
    }
    styles {
      pagePrimaryColor
      pageSecondaryColor
      textStyle {
        titleStyle {
          fontFamily
          fontSize
          primaryColor
          secondaryColor
        }
        bodyStyle {
          fontFamily
          fontSize
          primaryColor
          secondaryColor
        }
      }
      ctaButtonStyle {
        buttonColor
        fontFamily
        fontSize
        textColor
      }
    }
  }
`;
